import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Facebook from "../../assets/icons/facebook.svg";
import Insta from "../../assets/icons/insta.svg";
import Linkedin from "../../assets/icons/linkedin.svg";
import Youtube from "../../assets/icons/youtube.svg";
import Call from "../../assets/icons/call.svg";
import Message from "../../assets/icons/message.svg";
import Location from "../../assets/icons/gps.svg";
import "./index.css";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/images/logo-bmc-bus.svg";

const Index = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <Container>
        <div className="footer_wrapper">
          <Row className="m-0">
            <Col lg={4} className="p-0 first_col">
              <div className="firs_col_wrapper">
                <h5>
                  <img src={Logo} alt="Logo" style={{ width: "100px" }} />
                </h5>
                <p>{t("slogan_short")}</p>

                <p>{t("slogan_long")}</p>
              </div>
              <ul className="social_link d-sm-flex d-none">
                <li>
                  <Link>
                    <img src={Facebook} alt="facebook" />
                  </Link>
                </li>
                <li>
                  <Link>
                    <img src={Insta} alt="insta" />
                  </Link>
                </li>
                <li>
                  <Link>
                    <img src={Linkedin} alt="linkedin" />
                  </Link>
                </li>
                <li>
                  <Link>
                    <img src={Youtube} alt="Youtube" />
                  </Link>
                </li>
              </ul>
            </Col>
            <Col lg={7} className="links_wrapper">
              <Row>
                <Col lg={3} xs={6} className="links">
                  <h5>{t("quick_link")}</h5>
                  <ul>
                    <li>
                      <a
                        href="https://app.quotabus.com/9LRCMGJC"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("get_quote")}
                      </a>
                    </li>
                    <li>
                      <a href="#how_it_work_sec">{t("how_it_works")}</a>
                    </li>
                    <li>
                      <a href="#faqs">{t("faq")}</a>
                    </li>
                  </ul>
                </Col>
                <Col lg={3} xs={6} className="links">
                  <h5>{t("important_links")}</h5>
                  <ul>
                    <li>
                      <Link to="#terms">{t("terms_of_service")}</Link>
                    </li>
                    <li>
                      <a href="">{t("privacy_policy")}</a>
                    </li>
                    <li>
                      <a href="#contact_form">{t("contact_us")}</a>
                    </li>
                  </ul>
                </Col>
                <Col lg={4} xs={6} className="links contcat_info">
                  <h5>{t("contact_info")}</h5>
                  <ul>
                    <li>
                      <div>
                        <div className="icon_box">
                          <img src={Message} alt="message" />
                        </div>
                        <a
                          href="mailto:info@bmcnoleggio.it"
                          className="contact_email"
                        >
                          info@bmcnoleggio.it
                        </a>
                      </div>
                    </li>
                    <li>
                      <div>
                        <span className="icon_box">
                          <img src={Location} alt="location" />
                        </span>
                        <span className="contact_address">
                          Via Bra 105, 12062 CN
                        </span>
                      </div>
                    </li>
                  </ul>
                  <ul className="social_link d-sm-none d-flex">
                    <li>
                      <Link>
                        <img src={Facebook} alt="facebook" />
                      </Link>
                    </li>
                    <li>
                      <Link>
                        <img src={Insta} alt="insta" />
                      </Link>
                    </li>
                    <li>
                      <Link>
                        <img src={Linkedin} alt="linkedin" />
                      </Link>
                    </li>
                    <li>
                      <Link>
                        <img src={Youtube} alt="Youtube" />
                      </Link>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="copyright">
          <p>© 2024 BMC Noleggio. All Rights Reserved</p>
        </div>
      </Container>
    </footer>
  );
};

export default Index;
